import clsx from 'clsx'

const themedIconBoxStyle = {
  background: 'var(--theme-icon-box-background, color-mix(in srgb, var(--theme-primary) 15%, transparent))',
  color: 'var(--theme-icon-box-text, var(--theme-primary))',
}

export default function StatCard({ name, value, icon: Icon, color, useThemedIconBox = true, subtitle }) {
  const colorClasses = {
    primary: 'bg-theme-primary/20 text-theme-primary',
    success: 'bg-green-100 text-green-600',
    secondary: 'bg-theme-secondary/20 text-theme-secondary',
    warning: 'bg-yellow-100 text-yellow-600',
    error: 'bg-red-100 text-red-600',
  }

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p
            className={clsx(
              'text-sm font-medium',
              useThemedIconBox ? 'text-theme-primary' : 'text-gray-600',
            )}
          >
            {name}
          </p>
          <p
            className={clsx(
              'mt-2 text-3xl font-bold',
              useThemedIconBox ? 'text-theme-primary' : 'text-gray-900',
            )}
          >
            {value}
          </p>

          <div className="mt-2 flex items-center gap-1">
            <span className="text-sm font-medium text-gray-500">{subtitle}</span>
          </div>
        </div>

        {useThemedIconBox ? (
          <div className="icon-box icon-box-lg shrink-0" style={themedIconBoxStyle}>
            <Icon className="w-6 h-6" />
          </div>
        ) : (
          <div className={clsx('p-3 rounded-xl', colorClasses[color] || colorClasses.warning)}>
            <Icon className="w-6 h-6" />
          </div>
        )}
      </div>
    </div>
  )
}

